import React from 'react'
import styled from 'styled-components'
import { RoughBox, RoughCircle } from '../common/Rough'

const Description = styled.div`
    width: 100%;
    font-family: 'Kalam', cursive;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary};
    margin-bottom: 6px;
    @media only screen and (max-width: 768px){
        font-size: 13px;
    }
`

const CardOuter = styled.div`
  width: 650px;
  transform: rotate(-0.5deg);
  transition: transform 0.3s ease;
  &:hover {
    transform: rotate(0deg);
  }
  @media only screen and (max-width: 768px) {
    width: 300px;
  }
`;

const Top = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 14px
`

const Logo = styled.img`
    width: 26px;
    height: 26px;
    object-fit: contain;
    border-radius: 50%;
`

const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`


const Name = styled.div`
    font-family: 'Caveat', cursive;
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.text_primary};
    @media only screen and (max-width: 768px){
        font-size: 20px;
    }
`

const Degree = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 15px;
    font-weight: 700;
    color: ${({ theme }) => theme.primary};
    @media only screen and (max-width: 768px){
        font-size: 13px;
    }
`

const Date = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px){
        font-size: 11px;
    }
`

const Grade = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px){
        font-size: 13px;
    }
`



const EducationCard = ({ education }) => {
    return (
        <CardOuter>
            <RoughBox roughness={2.2} strokeWidth={1.7} padding="18px 22px" seed={education.id * 61 + 5}>
                <Top>
                    {education.img && (
                        <RoughCircle size={38} strokeWidth={1.3} roughness={2.3}>
                            <Logo src={education.img} />
                        </RoughCircle>
                    )}
                    <Body>
                        <Name>{education.school}</Name>
                        <Degree>{education.degree}</Degree>
                        <Date>{education.date}</Date>
                    </Body>
                </Top>
                <Grade><b>Grade: </b>{education.grade}</Grade>
                <Description>{education.desc}</Description>
            </RoughBox>
        </CardOuter>
    )
}

export default EducationCard
